/* eslint-disable max-lines-per-function */
import { handleDelete } from '@/domain/mitarbeiter/features/rotationsplan/features/DeleteRotationsplan/handleDelete';
import { useDeleteRotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useDeleteRotationsplan/useDeleteRotationsplan';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  Body,
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DropdownMenuItem,
} from '@e2n/ui/v2';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function DeleteRotationsplanDesktop({
  rotationsplanId,
  onClose,
}: {
  rotationsplanId: string;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { standorte } = useStandortContext();
  const standortIds = standorte.map((s) => s.id);
  const [deleteRotationsplan] = useDeleteRotationsplan(standortIds);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  function handleConfirm() {
    handleDelete({
      deleteRotationsplan,
      navigate,
      rotationsplanId,
      t,
      setIsSubmitting,
    });
  }

  return (
    <>
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="hidden md:flex">
          <DialogHeader>
            <DialogTitle>
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dialogTitle',
              )}
            </DialogTitle>
            <div className="flex flex-col gap-2">
              <DialogDescription>
                {t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dialogText',
                )}
              </DialogDescription>
              <Body className="text-error-red-200">
                {t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.infoStandortwechsel',
                )}
              </Body>
            </div>
          </DialogHeader>
          <DialogFooter variant="default">
            <Button
              onClick={() => {
                setIsOpen(false);
                onClose();
              }}
              variant="secondary-blue">
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dismiss',
              )}
            </Button>
            <Button
              disabled={isSubmitting}
              variant="primary-pill"
              onClick={handleConfirm}>
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.confirm',
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <DropdownMenuItem
        className="text-error-red-200"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}>
        {t(
          'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.label',
        )}
      </DropdownMenuItem>
    </>
  );
}
